/* eslint-disable @typescript-eslint/no-namespace */
export type OrderDetailsViewType =
    | OrderCheckoutViewType
    | OrderServiceActionViewType
    | "cancel-order"
    | "edit-customer"
    | "edit-service";

export type OrderCheckoutSummaryViewType = "order-summary" | "quote-summary";
export type OrderCheckoutRequestViewType = "request-order" | "request-quote";
export type OrderCheckoutViewType = OrderCheckoutSummaryViewType | OrderCheckoutRequestViewType;
export type OrderServiceActionViewType = "download-quote" | "download-order-confirmation" | "edit-service";

export namespace OrderDetailsViewType {
    export function isOrderCheckoutSummaryView(
        view: OrderDetailsViewType
    ): view is OrderCheckoutSummaryViewType {
        return view === "order-summary" || view === "quote-summary";
    }
    export function isCheckoutView(view: OrderDetailsViewType): view is OrderCheckoutViewType {
        return (
            view === "request-order" ||
            view === "request-quote" ||
            view === "order-summary" ||
            view === "quote-summary"
        );
    }
    export function isOrderCheckoutView(view: OrderDetailsViewType): view is OrderCheckoutViewType {
        return view === "request-order" || view === "order-summary";
    }
    export function isOrderServiceActionView(view: OrderDetailsViewType): view is OrderServiceActionViewType {
        return view === "download-quote" || view === "download-order-confirmation" || view === "edit-service";
    }

    export function getSummaryView(view: OrderCheckoutViewType): OrderDetailsViewType | undefined {
        return view === "request-order"
            ? "order-summary"
            : view === "request-quote"
              ? "quote-summary"
              : undefined;
    }
}
